import { Box, Stack, Typography } from '@mui/material';
import { InitiatePayoutResponse } from '../../../types/stripe';
import { formatDollarAmount } from '../../../utils/global/helper';

interface Props {
  data: InitiatePayoutResponse;
}

function PayoutSuccess({ data }: Props) {
  return (
    <Stack
      px={{
        xs: 4,
        md: 6,
      }}
      py={4}
      gap={1}
      width="100%"
      boxSizing="border-box"
      alignItems="center"
      justifyContent="center">
      <Box width="100%" maxWidth="180px" sx={{ aspectRatio: '1/1' }}>
        <img src="/money-tree.gif" alt="money-tree" width="100%" />
      </Box>

      <Typography variant="body2" textAlign="center">{`${formatDollarAmount(
        data.amount / 100,
        true,
      )} sent to your external account! It should arrive within 30 minutes. Note: This payout may not appear immediately in the payouts list.`}</Typography>
    </Stack>
  );
}

export default PayoutSuccess;
